
import './index.scss';
import listComponent from '@/util/proto/listComponent'
import FenceLayer from '../fence-layer'
import CarLayer from '../car-layer'
import carDetail from '../car-layer/item'
import fenceDetail from '../fence-layer/item'
import { getStaticPath } from '@/util/request'
import CarStats from '../car-stats'

/*
  { value: 0, label: '正常' },
  { value: 1, label: '禁用' },
  { value: 2, label: '已锁定' },
  { value: 3, label: '未启用' },
  { value: 6, label: '行驶中'},
*/
const statusIcon = [
  { value: 0, label: 'success' },
  { value: 1, label: 'error' },
  { value: 2, label: 'warning' },
  { value: 3, label: 'default' },
  { value: 6, label: 'processing'},
]

const isObjectValueEqual = (a, b) => {   
  if(!a || !b) return false

  let aProps = Object.getOwnPropertyNames(a);
  let bProps = Object.getOwnPropertyNames(b);

  if (aProps.length != bProps.length) {
      return false;
  }

  for (let i = 0; i < aProps.length; i++) {
    let propName = aProps[i];
    if (a[propName] !== b[propName]) {
        return false;
    }
  }
  return true;
}

export const carList = {
  extends: listComponent,
  props:['query'],
  data(){
    return {
      data:[],
      loading:false,
      stats:{
        bind:0 , 
        unbind:0
      }
    }
  },
  created(){
    this.$watch('query' , function(nv , ov){
      if(nv && !isObjectValueEqual(nv , ov)){
        this.search()
      }
    },{immediate:true , deep:false})
  },
  methods:{
    search(){
      this.data = []
      this.loading = true
      const params = {
        search:{...this.query , },
        pageSize: this.page.pageSize, 
        pageNum: this.page.pageNum ,
      }
      this.$request.carsLite(params).then( resp => {
        this.loading = false
        this.data = this.$utils.conv( resp.data.page.list || [] , { 'multipleState:statusIcon':statusIcon , 'multipleState':'carMultipleState' })
        this.page.total = resp.data.total || 0
        this.stats.bind = resp.data.bind
        this.stats.unbind = resp.data.unbind
      })
    },
    reset(){
      this.data = []
    },
    handleFullCar(){
      this.$emit('full')
    },
    toggleData(){

    },
    handleClick(data){
      this.$emit('click' , data)
    }
  },
  render(){
    const stats = this.stats
    return (
      <div class="db-map-car">
        <div class="db-map-car-full" on-click={this.handleFullCar}><Icon type="ios-arrow-back" /></div>
        <div class="db-map-car-stats">
          <div class="db-map-car-stats-item">
            <img src={getStaticPath('poi/1.png')} />
            已绑定 {stats.bind} 辆
          </div>
          <div class="db-map-car-stats-item">
            <img src={getStaticPath('poi/2.png')} />
            未绑定 {stats.unbind} 辆
          </div>
{/*          {
            stats.map( i => (
              <div class="db-map-car-stats-item">
                <img src={i.icon} />
                { i.title }
              </div>
            ))
          }*/}
        </div>
        <div class="db-map-car-content">
        <sl-spin loading={this.loading}>
          { 
            this.data.map(row => (
              <div class="db-map-car-item" on-click={() => this.handleClick(row)} >
                <sl-badge style={{'marginRight':'12px'}} status={row.statusIcon} />
                <div style={{'flex':'1 1 auto'}}>
                  <div class="tb-list-item-cell">
                    <div class="tb-list-item-cell-l" style="font-size:13px;">
                      <span>车辆编号:{row.carNo}</span>
                    </div>
                    <div class="tb-list-item-cell-r">
                      <span>{row.licenseNo}</span>
                    </div>
                  </div>
                  <div class="tb-list-item-cell">
                    <div class="tb-list-item-cell-l light">
                      <sl-tag style={{'fontSize':'12px','marginRight':'5px'}} color={row.statusIcon}>{row.multipleStateText}</sl-tag>
                    </div>
                    <div class="tb-list-item-cell-r">
                      <Icon style={{'marginRight':'5px'}} type="md-person-add" />
                      <span>{row.userName}</span>
                      <span>{row.phone}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))
          }
        </sl-spin>
        </div>
        <sl-pagination size="simple" page={this.page} on-change={this.$tableChange} style="padding:5px;text-align:center;" />
      </div>
    )
  }
}

const flatten = (d , pid = null) => d.reduce((t,c) => {
  let d = [].concat(t , {
    id:c.key ,
    key:c.id,
    title:c.name,
    count:c.count,
    parentId:pid,
    districtCode:c.districtCode
  })

  if(c.children){
    d = d.concat(flatten(c.children || [] , c.key))
  }

  if(c.companys){
    d = d.concat( c.companys.map(i => ({
      id:i.key , 
      key:i.id,
      fullname:i.companyName,
      title:i.companyName,
      parentId:c.key,
      count:i.count,
      districtCode:c.districtCode,
      leaf:true,
    })))
  }

  return d
} , [])


export const orgList = {
  data(){
    return {
      data:[],
      key:null,
      treeData:[]
    }
  },
  created(){
    this.query()
  },

  methods:{
    query(){
     
      this.$request('org_tree')().then(resp => {
        if( resp.code == 0 && resp.data ){
          this.data = flatten([resp.data])/*.map( i => ({
            key:i.key , 
            id:i.id , 
            title:i.name + ' ('+i.count+')',
            children:
          }))*/
          this.createTree(this.copyData())

          this.autoStart(resp.data)
        }
      })

    },
    autoStart(d){
      if(d){
        this.$emit('change' , {
          id:d.id , key:d.key , title:d.name , districtCode:d.districtCode
        })
      }
    },
    copyData(){
      return this.data.map(i => ({...i}))
    },
    onFilter(key){
      const data = key ? this.copyData().filter( i => {
        if(!i.id.toString().startsWith('c')) return true
        if(i.title && i.title.includes(key)) return true
      }) : this.copyData()
      this.createTree(data)
    },
    createTree(data){
      let dataMap = this.$utils.map(data , 'id')
      let newdata = {}
      data.filter( i => !!i.leaf ).forEach( i => {
          let pid = i.id
          do{
            newdata[pid] = dataMap[pid]
            pid = dataMap[pid].parentId
          }while(pid && dataMap[pid])
      })
      this.treeData = this.$utils.tree(Object.values(newdata))
    },

    handleClick(id , data){
      this.$emit('change',data)
    },

    queryCars(companyId){
      
    }
  },
  render(){
    const slots = {
      title:(data)=>{
        return <span style="display:flex;align-items: center;">{ data.leaf ? <Icon custom="i-icon icon-company" style="margin-right:3px;" /> : null } <span title={data.title} style="max-width:120px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{data.title}</span> ({data.count})</span>
      }
    }
    return <div class="db-map-org">
        <div class="db-map-org-search">
          <Input search v-model={this.key} size="small" on-on-search={this.onFilter} placeholder="搜索企业" />
        </div>
        <div class="db-map-org-content">
          <sl-tree data={this.treeData} scopedSlots={slots} size="sm" on-click={this.handleClick} />
        </div>
    </div>
  }
}

export const DbMenu = {
  props:['map' , 'fenceId'],
  data(){
    return {
      trafficActive:false,
      visibleCount:false,
      visibleFence:false
    }
  },
  created(){
    this.fenceLayer = new FenceLayer();
    this.fenceLayer.on('click' , (e , d) => {
      this.$emit('fence-click' , d)
    })

    this.$watch('fenceId' , function(nv){
      this.fenceLayer.focus( nv )
    })
  },
  methods:{
    handleToggleTraffic(){
      if( !this.map ) return 
      if (!this.trafficLayer) {
        this.trafficLayer = new AMap.TileLayer.Traffic();
      }

      this.trafficActive = !this.trafficActive
      if (this.trafficActive) {
        this.map.add(this.trafficLayer)
      } else {
        this.map.remove(this.trafficLayer)
      }
    },
    handleToggleVisibleCount(){
      
    },
    handleToggleFence(){
      this.visibleFence = !this.visibleFence
      if (this.visibleFence) {
        this.fenceLayer.setMap(this.map)
      } else {
        this.fenceLayer.setMap(null)
      }
    }
  },
  render(){
    return (
      <div class="db-map-menu">
        <a style="margin-left:5px;" class={{'active':this.trafficActive}} on-click={this.handleToggleTraffic}>
          <Icon custom="i-icon icon-traffic" />
          <span>路况</span>
        </a>
{/*        <a style="margin-left:5px;" class={{'active':this.visibleCount}} on-click={this.handleToggleVisibleCount}>
          <Icon type="ios-stats" />
          <span>统计</span>
        </a>*/}
        <a style="margin-left:5px;" class={{'active':this.visibleFence}} on-click={this.handleToggleFence}>
          <Icon custom="i-icon icon-polygon" />
          <span>围栏</span>
        </a>
      </div>
    )
  }
}




export default {
  data(){
    return {
      data:[],
      key:null,
      map:null,
      expand:true,
      carview:false,
      currentSelect:null,
      carStats:[],
      selectCar:null,
      selectFence:null
    }
  },
  created(){
    this.carLayer = new CarLayer()
    this.carLayer.on('update' , (e , data) => {
      //this.carLayerUpdate(data)
    })
    this.carLayer.on('click' , (e , data) => {
      this.handleSelectCar( data )
    })
    this.carLayer.on('focus' , (e , data) => {
      this.currentFocusCar = data
    })
  },
  computed:{
    placeholder(){
      if( this.currentCompany ){
        return '输入车辆编号/车牌号搜索'
      }else{
        return '输入企业名称搜索'
      }
    }
  },
  methods:{
    init(map){
      this.map = map
      
      this.carLayer.setMap(map)

      this.query()
    },

    /*
     * 
     */
    query(){

    },

    onFilter(key){
      this.key = key
      //
    },

    handleSelectCar(data){
      this.selectCar = data
      if( !('longitude' in data )){
        // 
      }else{
        let position = new AMap.LngLat(data.longitude, data.latitude)
        let fitZoom = Math.max(this.map.getZoom(), 16)
        this.map.setZoomAndCenter(fitZoom, position)
      }
    },

    onOrgChange(data){
      console.log(data)
      this.currentSelect = data
      if(data.leaf){
        this.carLayer.setOptions({companyId:data.key})
      }else{
        if( this.map ){
          this.map.setCity(data.title)
        }
        this.carLayer.setOptions({districtCode:data.districtCode})
      }
    },
    carLayerUpdate(data){
      this.carStats = data
    },
    onToggleExpand(){
      this.expand = !this.expand
    },

    handleFullCar(){
      this.carview = !this.carview
    },
    handleClose(){
      this.selectCar = null
    },
    handleFenceClick(data){
      if( this.currentFocusCar ){
        this.handleSelectCar(this.currentFocusCar)
        return
      }
      //console.log('handleFenceClick' , data)
      this.selectFence = data
    },
    handleFenceClose(){
      this.selectFence = null
    },
    handleUpdateCarPosition(data = {}){
      if( data.longitude && data.latitude ){
        let position = new AMap.LngLat(data.longitude, data.latitude)
        let fitZoom = Math.max(this.map.getZoom(), 16)
        this.map.setZoomAndCenter(fitZoom, position)
      }
    }
  },
  render(){
    const { currentSelect , expand , carview , selectCar , selectFence } = this

    let selectNode = null

    if(carview){
      selectNode = <Icon title={currentSelect.title} on-click={this.handleFullCar} size={20} type="md-map" style="margin-right:3px;" />
    }else{
      if(currentSelect){
        selectNode = <div title={currentSelect.title} class="db-map-search-head" style="max-width:150px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;" on-click={this.handleFullCar}>{currentSelect.title}</div>
      }
    }

    const carQuery = {}

    if( currentSelect ){
      if(currentSelect.leaf){
        carQuery.companyId = currentSelect.key
      }else{
        carQuery.districtCode = currentSelect.districtCode
      }
    }

    if( this.key ){
      carQuery.text = this.key
    }

    const detailView = !!selectCar
    const fencelView = !!selectFence
    const map = this.map
    const theme = "whitesmoke" //whitesmoke darkblue

    const currentFence = selectFence ? selectFence.id : null
    const currentCar = selectCar ? selectCar.carNo :null
    return (
      <div style="width:100%;height:100%;">
        <sl-amap class="map" view-mode="2d" theme={theme} zoom={4} on-ready={this.init} />
        <div class={{'db-map-ctrl':1 , 'db-map-ctrl-mini':!expand , 'db-map-ctrl-carview':carview , 'db-map-detail-view':detailView,'db-map-fence-view':fencelView}}>
          <div class="db-map-search">
            {selectNode}
            <div>
              <Input search on-on-search={this.onFilter} placeholder="车辆编号/快递员/车牌号 搜索" />
            </div>
            <DbMenu map={map} fence-id={currentFence} on-fence-click={this.handleFenceClick} />
          </div>
          <div class="db-map-content-wrap">
            <div class="db-map-content">
              <orgList enable-title-expand={false} on-change={this.onOrgChange} keyword={this.key}/>
              <carList query={carQuery} on-click={this.handleSelectCar} stats={this.carStats} on-full={this.handleFullCar} />
            </div>
            
            <div class="db-map-content-expand" on-click={this.onToggleExpand}>
              <Icon type="ios-arrow-up" />
            </div>
          </div>
          <div>
            <carDetail carNo={currentCar} on-update-position={this.handleUpdateCarPosition} on-close={this.handleClose} />
            <fenceDetail data={selectFence} on-close={this.handleFenceClose} />
          </div>
        </div>
        {
          this.$slots
        }
      </div>
    )
  }
}

